import { render, staticRenderFns } from "./aufgaben-flugdetails.vue?vue&type=template&id=62701dca"
import script from "./aufgaben-flugdetails.vue?vue&type=script&lang=js"
export * from "./aufgaben-flugdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports